import {
  initialState,
  Actions,
  State,
  NEW_CONTACT,
  NEW_CONTACT_SUCCESS,
  NEW_CONTACT_ERROR,
  RESET_NEW_CONTACT,
} from '../../types/contact/new'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case NEW_CONTACT:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case NEW_CONTACT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case NEW_CONTACT_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_NEW_CONTACT:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
